import {
  Area,
  CellPosition,
  EntitySize,
  GridEntity,
  IRange,
  NumberFormat,
  Sheet,
  Style,
  ValidationRule,
} from '../../sheet';

export enum SheetCommandType {
  CreateSheet = 'CreateSheet',
  DeleteSheet = 'DeleteSheet',

  FreezeGrid = 'FreezeGrid',
  // UnfreezeGrid = 'UnfreezeGrid',
  HideGrid = 'HideGrid',
  UnhideGrid = 'UnhideGrid',
  GroupGrid = 'GroupGrid',
  UngroupGrid = 'UngroupGrid',
  ResizeGrid = 'ResizeGrid',

  CellInput = 'CellInput',
  NumberFormat = 'NumberFormat',
  Styles = 'Styles',
  ApplyDataValidation = 'ApplyDataValidation',
  RemoveDataValidation = 'RemoveDataValidation',

  ApplyConditionalFormat = "ApplyConditionalFormat",
  RemoveConditionalFormat = "RemoveConditionalFormat"
}

export interface CreateSheet {
  type: SheetCommandType.CreateSheet;
  sheet: Sheet;
  exportedFeKey?: string;
  groupId?: string;
}

export interface DeleteSheet {
  type: SheetCommandType.DeleteSheet;
  sheetId: string;
  groupId?: string;
}

interface BasicGridOp {
  sheetId: string;
  entity: GridEntity;
}

export interface HideUnhideGrid extends BasicGridOp {
  type: SheetCommandType.HideGrid | SheetCommandType.UnhideGrid;
  ranges: IRange[];
}

export interface FreezeGrid extends BasicGridOp {
  type: SheetCommandType.FreezeGrid; //| SheetCommandType.UnfreezeGrid;
  range: IRange;
}

export interface GroupUngroupGrid extends BasicGridOp {
  type: SheetCommandType.GroupGrid | SheetCommandType.UngroupGrid;
  ranges?: IRange[];
  groupId?: string;
}

export interface ResizeGrid extends BasicGridOp {
  type: SheetCommandType.ResizeGrid;
  size?: number;
  positionIndex?: number;
  rangeSizes?: EntitySize[];
}

export type GridCommand =
  | HideUnhideGrid
  | FreezeGrid
  | GroupUngroupGrid
  | ResizeGrid;

export interface CellInput {
  type: SheetCommandType.CellInput;
  position: CellPosition;
  value: string;
  sheetId: string;
}

export interface AreaNumberFormat {
  area: Area;
  format: NumberFormat;
}

export interface CellNumberFormat {
  sheetId: string;
  type: SheetCommandType.NumberFormat;
  formats: AreaNumberFormat[];
  // areas: Area[];
  // format: NumberFormat;
}

export interface AreaStyle {
  area: Area;
  style: Style;
}

export interface CellStyle {
  sheetId: string;
  type: SheetCommandType.Styles;
  styles: AreaStyle[];
}

// export interface AreaDataValidation {
//   area: Area;
//   validation: ValidationRule;
// }

export interface ApplyCellDataValidation {
  sheetId: string;
  type: SheetCommandType.ApplyDataValidation;
  rules: ValidationRule[];
}

export interface RemoveCellDataValidation {
  sheetId: string;
  type: SheetCommandType.RemoveDataValidation;
  ruleIds: string[];
}

export interface ApplyCellConditionalFormat {
  sheetId: string;
  type: SheetCommandType.ApplyConditionalFormat,
}

export interface RemoveCellConditionalFormat {
  sheetId: string
  type: SheetCommandType.RemoveConditionalFormat
}

export type CellCommand =
  | CellInput
  | CellNumberFormat
  | CellStyle
  | ApplyCellDataValidation
  | RemoveCellDataValidation
  | ApplyCellConditionalFormat
  | RemoveCellConditionalFormat

export type SheetCommand =
  | CreateSheet
  | DeleteSheet
  | GridCommand
  | CellCommand;
